import { digObject } from '@domain-group/javascript-utils'
import { getComparableType } from '@functions/campaignComparable'

import buildMinMaxValues from './buildMinMaxValues'

import type { ComparableFilterKeys, FilterModel } from './filterModel'

type BuildBrowseFiltersParams = {
  filters?: { [key in ComparableFilterKeys]: FilterModel },
  comparableType: string,
}

export const buildBrowseFilters = (params: BuildBrowseFiltersParams) => {
  const { filters, comparableType } = params
  const {
    area,
    bathrooms,
    bedrooms,
    carparks,
    price,
  } = filters || {}

  // @ts-expect-error TS2345
  const propertyTypeValue = digObject(filters, 'property_type.value', '')
  // @ts-expect-error TS2345
  const radiusValue = digObject(filters, 'radius.value', '5')
  // @ts-expect-error TS2345
  const sortValue = digObject(filters, 'sort.value', 'distance')

  // @ts-expect-error TS2345
  const soldEndDate = digObject(filters, 'sold_date.valueMax', '')
  // @ts-expect-error TS2345
  const soldStartDate = digObject(filters, 'sold_date.value', '')

  const comparable_type = getComparableType(comparableType)

  const basicFilters = {
    comparable_type,
    date_end: soldEndDate || 'now',
    date_start: soldStartDate || 'today-1y',
    limit: comparable_type === 'all' ? 25 : 50,
    property_type: propertyTypeValue,
    radius: radiusValue,
    sort: sortValue,
  }

  // @ts-expect-error TS2345
  const areaValues = buildMinMaxValues('area', area)
  // @ts-expect-error TS2345
  const bathroomsValues = buildMinMaxValues('baths', bathrooms)
  // @ts-expect-error TS2345
  const bedroomsValues = buildMinMaxValues('beds', bedrooms)
  // @ts-expect-error TS2345
  const carparksValues = buildMinMaxValues('car_parks', carparks)
  // @ts-expect-error TS2345
  const priceValues = buildMinMaxValues('price', price)

  return {
    ...areaValues,
    ...basicFilters,
    ...bathroomsValues,
    ...bedroomsValues,
    ...carparksValues,
    ...priceValues,
  }
}

export default buildBrowseFilters
